<div *ngIf="isRequestForForeituresInFlight" class="text-center">
  <i id="forfeitures-view-spinner" class="fa fa-spinner fa-spin fa-5x text-center"></i>
</div>
<div *ngIf="!isRequestForForeituresInFlight">
<div *ngIf="bondsman.getBondForfeitureList(bondsman, getSelectedCounty(), getSelectedJudgment(), getSelectedLicenseType()).length === 0">
    <div class="panel-body ">
      <div class="row ">
        No pending forfeitures or final judgments found for the licensee.
      </div>
    </div>
</div>
<div  *ngIf="bondsman.getBondForfeitureList(bondsman, getSelectedCounty(), getSelectedJudgment(), getSelectedLicenseType()).length > 0" class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
  <div class="panel-body ">
    <div class="row ">
      <div class="table-responsive" [class.scroll-hide-xy]="true">
        <table id="forfeiture-table" class="table table-condensed table-striped panel-title" border=0px>
          <thead>
          <tr>
            <td width="25%" colspan=3 valign=top align=center><b>Forfeiture Information<hr class="hr-forfeitures-header"></b></td>
            <td width="25%" colspan=2 valign=top align=center><b>Judgment Information<hr class="hr-forfeitures-header"></b></td>
            <td width="40%" colspan=4 valign=top align=center><b>Bond Information<hr class="hr-forfeitures-header"></b></td>
          </tr>
          <tr>
            <td id="forfeiture-table-county-title" *ngIf="getCountyList(bondsman).length > 2">
              <span class="field-code ">V629</span>
              <div class="btn-group">
                <span dropdown id="forfeiture-table-county-dropdown">
                  <a href dropdownToggle (click)="false" class="match-type-dropdown">
                    <b>County</b>
                  </a>
                  <ul *dropdownMenu class="dropdown-menu">
                    <li *ngFor="let county of getCountyList(bondsman); let i=index;">
                      <a id="{{'forfeiture-table-county-' + county}}" tabindex="{{195 + i}}" class="dropdown-item" (click)="selectedCountyFilter(county)">{{county}}</a>
                    </li>
                  </ul>
                </span>
              </div>
            </td>
            <td id="forfeiture-table-county-title" *ngIf="getCountyList(bondsman).length === 2">
                <span class="field-code ">V629</span><b>County</b>
            </td>
            <td id="forfeiture-table-case-number-title">
              <span class="field-code ">V627</span><b>Case Number</b>
            </td>
            <td id="forfeiture-table-filing-title">
              <span class="field-code ">V628</span><b>Filing</b>
            </td>
            <td id="forfeiture-table-judgment-date-title">
              <span class="field-code ">V630</span><b>Judgment Date</b>
              <span popover="Judgment date description." popoverTitle="Judgment Date" (mouseover)="popOverHandler('onShow')"
                (mouseleave)="popOverHandler('onHide')">
                <i class="fa fa-info-circle"></i>
              </span>
            </td>
            <td id="forfeiture-table-judgment-title" *ngIf="getJudgmentList(bondsman).length > 2">
              <span class="field-code ">V639</span>
              <div class="btn-group">
                <span dropdown id="forfeiture-table-judgment-dropdown">
                  <a href dropdownToggle tabindex="191" (click)="false" class="match-type-dropdown">
                    <b>Judgment</b> <span popover="Judgment description." popoverTitle="Judgment" (mouseover)="popOverHandler('onShow')"
                    (mouseleave)="popOverHandler('onHide')">
                    <i class="fa fa-info-circle"></i>
                  </span>
                  </a>
                  <ul *dropdownMenu class="dropdown-menu">
                    <li *ngFor="let judgment of getJudgmentList(bondsman); let i=index;">
                      <a id="{{'forfeiture-table-judgment-' + judgment}}" tabindex="{{195 + i}}" class="dropdown-item" (click)="selectedJudgmentFilter(judgment)">{{judgment}}</a>
                    </li>
                  </ul>
                </span>
              </div>
            </td>
            <td id="forfeiture-table-judgment-title" *ngIf="getJudgmentList(bondsman).length === 2">
                <span class="field-code ">V639</span>
                <b>Judgment</b> <span popover="Judgment description." popoverTitle="Judgment" (mouseover)="popOverHandler('onShow')"
                (mouseleave)="popOverHandler('onHide')">
                <i class="fa fa-info-circle"></i>
              </span>
            </td>
            <td id="forfeiture-table-bond-date-title">
              <span class="field-code ">V631</span><b>Bond Date</b>
            </td>
            <td id="forfeiture-table-bond-amount-title">
              <span class="field-code ">V632</span><b>Bond Amount</b>
            </td>
            <td id="forfeiture-table-license-type-title" *ngIf="getLicenseTypeListForFilter(bondsman).length > 2">
              <span class="field-code ">V636</span>
              <a (click)="selectedLicenseTypeFilter(bondsman)" class="clickable"></a>
              <div class="btn-group">
                <span dropdown id="forfeiture-table-dropdown">
                  <a href dropdownToggle tabindex="191" (click)="false" class="match-type-dropdown">
                    License Type
                  </a>
                  <ul *dropdownMenu class="dropdown-menu">
                    <li *ngFor="let license of getLicenseTypeListForFilter(bondsman); let i=index;">
                      <a id="{{'forfeiture-table-license-type-' + license}}" tabindex="{{195 + i}}" class="dropdown-item" (click)="selectedLicenseTypeFilter(license)">{{license}}</a>
                    </li>
                  </ul>
                </span>
              </div>
            </td>
            <td id="forfeiture-table-license-type-title" *ngIf="getLicenseTypeListForFilter(bondsman).length === 2">
                <span class="field-code ">V636</span>
                <b>License Type</b>
            </td>
            <td id="forfeiture-table-other-license-title">
              <span class="field-code ">V637</span><b>Other Licensee</b>
            </td>
            <td id="forfeiture-table-motion-title">
              <span class="field-code ">V634</span><b>Motion</b>
            </td>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let forfeiture of bondsman.getBondForfeitureList(bondsman, getSelectedCounty(), getSelectedJudgment(), getSelectedLicenseType()); let i = index">
              <td id="{{'bondsmanDetails-bondForfeiture-county-' + i}}">
                {{bondsman.getForfeitureCounty(forfeiture)}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-caseNumber">
                <a (click)="onViewCaseSelected(bondsman, forfeiture)" class="clickable">
                  {{bondsman.getForfeitureCaseNumber(forfeiture) }}</a>
              </td>
              <td id="bondsmanDetails-bondForfeiture-pleading">
                {{bondsman.getForfeiturePleading(forfeiture)}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-judgmentDate">
                {{bondsman.getForfeitureJudgmentDate(forfeiture) | date:'MM/dd/yyyy'}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-judgment">
                {{bondsman.getForfeitureJudgment(forfeiture)}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-BondDate">
                {{bondsman.getForfeitureBondDate(forfeiture) | date:'MM/dd/yyyy'}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-bondAmount">
                {{bondsman.getForfeitureBondAmount(forfeiture) | currency:'USD':'symbol':'1.2-2'}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-licenseType">
                {{bondsman.getForfeitureLicenseType(forfeiture)}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-otherLicense">
                {{bondsman.getForfeitureOtherLicense(forfeiture)}}
              </td>
              <td id="bondsmanDetails-bondForfeiture-motion">
                {{bondsman.getForfeitureMotion(forfeiture)}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bond-forfeitures/bond-forfeitures.component.html